<template>
  <Layout>
    <template v-slot:left>
      <ButtonBackList :toUrl="toUrl" />
      <ButtonSave
        :form="form"
        @toggleIsRegistering="$emit('toggleIsRegistering')"
      />
    </template>
    <template v-slot:right>
      <ButtonPrev />
      <ButtonNext :form="form" />
    </template>
  </Layout>
</template>

<script>
import ButtonNext from '@/components/Shared/Simulation/SimulationFooterButtonNext'
import ButtonPrev from '@/components/Shared/Simulation/SimulationFooterButtonPrev'
import ButtonBackList from '@/components/Shared/Simulation/SimulationFooterButtonBackList'
import ButtonSave from '@/components/Shared/Simulation/SimulationFooterAddButtonSave'
import Layout from '@/components/Shared/Simulation/SimulationFooterLayout'

export default {
  name: 'SimulationFooterAdd',
  components: {
    Layout,
    ButtonNext,
    ButtonPrev,
    ButtonBackList,
    ButtonSave,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toUrl: '../simulations',
    }
  },
}
</script>

<style scoped></style>
